/** Sufixos societários que não entram nas iniciais do avatar. */
const CORPORATE_SUFFIXES = new Set(['SA', 'LTDA', 'ME', 'EIRELI', 'EPP', 'MEI']);

/** Remove pontuação e normaliza para comparação/exibição em maiúsculas. */
function normalizeToken(token: string): string {
  return token.toUpperCase().replace(/[./-]/g, '');
}

/**
 * Iniciais do avatar da empresa: quebra por espaço e underscore, descarta
 * sufixos societários e usa a primeira letra dos dois primeiros tokens.
 * `STG_MEDIFARMA S.A.` resulta em `SM`.
 */
export function buildCompanyInitials(name: string | null | undefined): string {
  const tokens = (name ?? '')
    .split(/[\s_]+/)
    .filter(token => token.trim().length > 0)
    .filter(token => !CORPORATE_SUFFIXES.has(normalizeToken(token)));

  if (tokens.length === 0) {
    return '';
  }

  if (tokens.length === 1) {
    return normalizeToken(tokens[0]).slice(0, 2);
  }

  return tokens
    .slice(0, 2)
    .map(token => normalizeToken(token).charAt(0))
    .join('');
}

/** `Lima, PE`, omitindo a parte que não existir. */
export function formatCompanyLocation(
  city: string | null | undefined,
  state: string | null | undefined
): string {
  return [city, state]
    .map(part => (part ?? '').trim())
    .filter(part => part.length > 0)
    .join(', ');
}
